var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "panel",
      class: { "panel-sm": _vm.windowIsSmall },
      style: { borderTop: "1px solid " + _vm.$themePalette.grey.v_200 },
    },
    [
      _c("ChannelDetails", {
        attrs: { channel: _vm.channel },
        scopedSlots: _vm._u([
          {
            key: "belowname",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "private-icons" },
                  [
                    _c(
                      "KTooltip",
                      {
                        attrs: {
                          reference: "lockicon",
                          refs: _vm.$refs,
                          placement: "top",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.deviceString("unlistedChannelLabel")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm.channel.public === false
                      ? _c("KIcon", {
                          ref: "lockicon",
                          staticClass: "lock-icon",
                          attrs: { icon: "unlistedchannel" },
                        })
                      : _vm._e(),
                    _vm.showNewLabel
                      ? _c("NewBadge", {
                          staticClass: "new-label",
                          attrs: { label: _vm.deviceString("newChannelLabel") },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        {
          staticClass: "col-2",
          attrs: { dir: "auto", "data-test": "resources-size" },
        },
        [_vm._v("\n    " + _vm._s(_vm.resourcesSizeText) + "\n  ")]
      ),
      _c(
        "div",
        { staticClass: "col-3" },
        [
          _c("KButton", {
            attrs: {
              text: _vm.$tr("manageChannelAction"),
              disabled: _vm.disabled,
            },
            on: { click: _vm.handleManageChannelAction },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }